module.exports = __webpack_public_path__ + "static/szenario2-e20d853fe46e08579d1006c5819a4444.png";